import {get as _get} from 'lodash';
import PropTypes from 'prop-types';

import {showCopyableIdTooltip} from '@utils/eventDetailsHelper';

/**
 * Get value from object structure with properties:
 * - srWithMatchID,
 * - srWithoutMatchID,
 * - nonSr
 *
 * for different type of event
 */
export const getProperty = ({ data, srWithMatchID = [], srWithoutMatchID = [], nonSr = [] }, propertyName = 'name') => {
    if (data.sr_event) {
        if (data._hasMatchID) {
            return _get(data.sr_event, [...srWithMatchID, propertyName], null);
        }

        return _get(data.sr_event, [...srWithoutMatchID, propertyName], null);
    }

    return _get(data.av_event, [...nonSr, propertyName], null);
};

export const copyableProperty = (eventData, columnName, nameOverride) => showCopyableIdTooltip(
    nameOverride ?? getProperty(eventData, 'name'),
    getProperty(eventData, 'id'),
    columnName
);

getProperty.propTypes = {
    data: PropTypes.shape({
        sr_event: PropTypes.object,
        av_event: PropTypes.object,
    }),
    _hasMatchID: PropTypes.bool.isRequired,
};

getProperty.defaultProps = {
    data: {
        sr_event: null,
        av_event: null,
    },
};

export const getContentTierName = (data) => {
    let contentTier = data?.propertyLicenceContent?.content_tier?.name;

    return contentTier ? ` (${contentTier})` : '';
};

getContentTierName.propTypes = {
    data: PropTypes.shape({
        av_event: PropTypes.object,
        property_licence: PropTypes.shape({
            contents: PropTypes.array,
        }),
        sr_event: PropTypes.object,
    }),
    _hasMatchID: PropTypes.bool.isRequired,
};

getContentTierName.defaultProps = {
    data: {
        av_event: null,
        property_licence: {
            contents: [],
        },
        sr_event: null,
    },
};
